module.exports = "/_next/static/images/ico_yb.07EdLiYC.ico";